<template>
  <div class="fldy-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
<!--            这个完工时间指的是订单生产明细表里的全入库时间-->
            <el-form-item label="完工时间">
              <el-date-picker
                v-model="searchForm.opertime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="合同编号"
                    width="120"
                    align="center"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF" v-if="scope.row.produnum!==''&&scope.row.produnum!==null">{{ scope.row.produnum }}</span>
                      <span v-if="scope.row.produnum===''||scope.row.produnum===null" style="color: #99a9bf;">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    align="center"
                    width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.allname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="客户地址"
                    min-width="240"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单颜色"
                    width="240"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.crafts===null||scope.row.crafts===''||scope.row.crafts===undefined" >N/A</span>
                      <span v-else>{{scope.row.crafts}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="下单时间"
                    width="170"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="预付款时间"
                    width="170"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.subsist_time===null||scope.row.subsist_time===''||scope.row.subsist_time===undefined">{{scope.row.time}}</span>
                      <span v-else>{{scope.row.subsist_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="完工时间"
                    width="170"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.complete}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单总件数"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.comnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包装总包数"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.packnum}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { exportFinishReportList, selectFinishReport } from '@/api/erp'

export default {
  name: 'wgbg',
  computed: {
    user: getUser
  },
  data() {
    return {
      exportLoading: false,
      searchForm: {
        search: null,
        opertime: []
      },
      loading: false,
      tableData: [],
      total: null,
      currentPage: 1,
      pageSize: 20

    }
  },
  created() {
    this.getData()
  },
  methods: {
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.orderid })
    },
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        let startTime = ''
        let endTime = ''
        if (this.searchForm.opertime !== null && this.searchForm.opertime.length === 2) {
          startTime = this.searchForm.opertime[0]
          endTime = this.searchForm.opertime[1]
        }
        const data = {
          content: this.searchForm.search,
          starttime: startTime,
          endtime: endTime,
          userid: this.user.dUserid,
          role: this.user.role,
          groupid: this.user.dGroupid
        }
        this.$message({
          message: '数据正在导出，请稍候'
        })
        exportFinishReportList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    getData() {
      this.loading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime.length === 2) {
        startTime = this.searchForm.opertime[0]
        endTime = this.searchForm.opertime[1]
      }
      const data = {
        content: this.searchForm.search,
        starttime: startTime,
        endtime: endTime,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        role: this.user.role,
        groupid: this.user.dGroupid
      }
      selectFinishReport(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .fldy-container {
    .tcf-row{
      .card{
        .card-body{
          .card-title{
            .search-mode{
              width: 300px;
              position: relative;
              float: right;
              margin-top: -10px;
              .search-input{
                background-color: #F2F6FC;
                border:0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;
                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }
                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }
              .search-btn{
                position: absolute;
                right: 0;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
            }
          }
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .client-sex{
              width: 16px!important;
              height: 16px!important;
              vertical-align: -4px!important;
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
</style>
